"use client"
import { Link, useLocation } from "react-router-dom"
import { motion, AnimatePresence } from "framer-motion"
import {
  Home,
  Music,
  Video,
  Laugh,
  Volume2,
  Quote,
  Image,
  Moon,
  Sun,
  Menu,
  Mail,
  X,
} from "lucide-react"

const Sidebar = ({ darkMode, toggleDarkMode, isOpen, toggleSidebar }) => {
  const location = useLocation()

  const sidebarVariants = {
    open: { x: 0 },
    closed: { x: "-100%" },
  }

  const menuItems = [
    { path: "/", icon: Home, label: "Home" },
    { path: "/lyrics-finder", icon: Music, label: "Lyrics Finder" },
    { path: "/video-downloader", icon: Video, label: "Video Downloader" },
    { path: "/programming-memes", icon: Laugh, label: "AI Programming Memes" },
    { path: "/audio-to-text", icon: Volume2, label: "AI Audio to Text" },
    { path: "/quotes-generator", icon: Quote, label: "AI Quotes Generator" },
    { path: "/ai-skin-beauty", icon: Image, label: "AI Skin Beauty" },
    { path: "/feedback", icon: Mail , label: "Feedback" },
  ]

  return (
    <>
      <button
        onClick={toggleSidebar}
        className="fixed top-4 left-4 z-50 md:hidden bg-indigo-600 text-white p-2 rounded-full shadow-lg"
        aria-label="Toggle Sidebar"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      <AnimatePresence>
        {(isOpen || window.innerWidth >= 768) && (
          <motion.aside
            initial="closed"
            animate="open"
            exit="closed"
            variants={sidebarVariants}
            transition={{ duration: 0.3, type: "tween" }}
            className="fixed left-0 top-0 bottom-0 w-64 bg-indigo-600 text-white p-6 overflow-y-auto z-40 md:sticky"
          >
            <h1 className="text-2xl font-bold mb-8">Gennie Tools</h1>
            <nav>
              <ul className="space-y-4">
                {menuItems.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`flex items-center space-x-2 p-2 rounded-lg transition-colors duration-200 ${
                        location.pathname === item.path
                          ? "bg-indigo-700 text-white"
                          : "hover:bg-indigo-700 hover:text-white"
                      }`}
                      onClick={() => window.innerWidth < 768 && toggleSidebar()}
                    >
                      <item.icon size={20} />
                      <span>{item.label}</span>
                    </Link>
                  </li>
                ))}
                
              </ul>
            </nav>
            <button
              onClick={toggleDarkMode}
              className="mt-8 flex items-center space-x-2 p-2 rounded-lg hover:bg-indigo-700 transition-colors duration-200"
            >
              {darkMode ? <Sun size={20} /> : <Moon size={20} />}
              <span>{darkMode ? "Light Mode" : "Dark Mode"}</span>
            </button>
          </motion.aside>
        )}
      </AnimatePresence>
    </>
  )
}

export default Sidebar

